import { useEffect } from 'react';

export function useDisableZoom() {
  useEffect(() => {
    function handleKeyDown(e) {
      // Block Ctrl+/Ctrl-/Ctrl+0
      if (e.ctrlKey && (e.key === '+' || e.key === '=' || e.key === '-' || e.key === '0')) {
        e.preventDefault();
      }
    }

    function handleWheel(e) {
      // Block Ctrl+scroll wheel
      if (e.ctrlKey) {
        e.preventDefault();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('wheel', handleWheel);
    };
  }, []);
}
